import React, { useState } from 'react'

import { ArrowDown } from '../../icons/ArrowDown'
import styles from './filtersDropdown.module.scss'
import { FiltersDropdownTypes, Option } from './FiltersDropdown.types'

export const FiltersDropdown: React.FC<FiltersDropdownTypes> = ({
  options,
  onSelect,
  label,
  selected,
  btnText = 'Не важно',
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const [selectedOption, setSelectedOption] = useState<Option | null>(null)

  const handleToggle = () => {
    setIsOpen(!isOpen)
  }

  const handleSelect = (option: Option) => {
    setSelectedOption(option)
    onSelect(option.value)
    setIsOpen(false)
  }

  return (
    <div className={styles.dropdown}>
      {label && <p className={styles.dropdownLabel}>{label}</p>}
      <button className={styles.dropdownButton} onClick={handleToggle}>
        {selectedOption ? selectedOption.label : btnText}
        <ArrowDown />
      </button>
      {isOpen && (
        <ul className={styles.dropdownOptions}>
          {options.map(option => (
            <li
              key={option.value}
              className={
                selected === option.value
                  ? styles.selectedOption
                  : styles.dropdownOption
              }
              onClick={() => handleSelect(option)}
            >
              {option.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}
